import React from 'react';
import athenaLogo from '../../resources/athenaLogoNoText.jpg';
import arsinoeLogo from '../../resources/logoArsinoeNoText.png';
import narraliveLogo from '../../resources/narraliveLogo.png';

const Footer = () => {
    return (
        <footer className="bg-gray-800 text-white py-4 flex flex-col md:flex-row justify-between items-center px-6">
        {/* Copyright Section */}
        <div className="text-sm mb-4 md:mb-0">
            &copy; {new Date().getFullYear()} Arsinoe Project and Narralive Team. All rights reserved.
        </div>

        {/* Navigation Links 
        <div className="flex space-x-4 mb-4 md:mb-0">
            <Link to="/" className="nav-link hover:underline">
                Home
            </Link>
            <Link to="/team" className="nav-link hover:underline">
                Team
            </Link>
            <Link to="/about" className="nav-link hover:underline">
                About
            </Link>
        </div>
        */}
        {/* Logos and Company Names */}
        <div className="flex items-center space-x-8">
            {/* Company 1 */}
            <div className="flex items-center space-x-2">
                <img
                    src={athenaLogo}
                    alt="Athena Research Center Logo"
                    className="w-8 h-8 object-contain"
                />
                <a
                    href="https://www.athenarc.gr/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm font-medium hover:underline"
                >Athena Research Center</a>
            </div>

            {/* Company 2 */}
            <div className="flex items-center space-x-2">
                <img
                    src={arsinoeLogo}
                    alt="Arsinoe Project Logo"
                    className="w-8 h-8 object-contain"
                />
                <a
                    href="https://arsinoe-project.eu/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm font-medium hover:underline"
                >Arsinoe Project</a>
                
            </div>
            {/* Company 3 */}
            <div className="flex items-center space-x-2">
                <img
                    src={narraliveLogo}
                    alt="Narralive Logo"
                    className="w-8 h-8 object-contain"
                />
                <a
                    href="https://www.narralive.org/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm font-medium hover:underline"
                >Narralive</a>
                
            </div>
        </div>
    </footer>
    );
}

export default Footer;
